import React from "react";
// import { useTranslation } from "react-i18next";

const Nutrition = () => {
  // const { t } = useTranslation();

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="text-center mb-10">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">
          營養照護與建議
        </h1>
        <p className="max-w-2xl mx-auto text-gray-700">
          你如果有肺阻塞，光是喘氣，身體就比別人更費力，消耗也比較大。所以你要吃得夠、吃得對，才有力氣幫助呼吸。
        </p>
      </div>

      <div className="bg-white rounded-lg shadow-lg p-6 mb-8">
        <h2 className="text-2xl font-semibold text-green-900 mb-4">
          如果吃不夠，可能會發生：
        </h2>
        <ul className="list-disc pl-6 text-gray-700 mb-4">
          <li>身體變瘦、肌肉變少</li>
          <li>呼吸用的肌肉變沒力，越喘越嚴重</li>
          <li>比較容易感染、住院</li>
        </ul>
      </div>

      <div className="bg-white rounded-lg shadow-lg p-6 mb-8">
        <h2 className="text-2xl font-semibold text-green-900 mb-4">
          怎麼吃才對？
        </h2>
        <ul className="list-disc pl-6 text-gray-700 mb-4">
          <li>蛋白質要夠（像魚肉、豆腐、雞蛋）</li>
          <li>每公斤體重約要吃 1.2～1.5 克</li>
          <li>熱量也要夠（大約一天吃體重乘 30 大卡）</li>
          <li>一天吃 4～6 小餐，不要等太餓才吃</li>
        </ul>
      </div>

      {/* 補充：適合的食物 */}
      <div className="bg-white rounded-lg shadow-lg p-6 mb-8">
        <h2 className="text-2xl font-semibold text-green-900 mb-4">
          什麼樣的食物比較適合？
        </h2>
        <ul className="list-disc pl-6 text-gray-700 mb-4">
          <li>食物選軟的、好咬的，像地瓜、軟飯、蒸蛋、豆腐</li>
          <li>肉類剁碎、魚選沒刺的</li>
          <li>可以加堅果粉進牛奶或稀飯裡增加熱量</li>
          <li>蔬菜煮軟，水果選香蕉、木瓜，或打成果汁喝</li>
        </ul>
      </div>
      {/* 補充：太瘦怎麼辦 */}
      <div className="bg-white rounded-lg shadow-lg p-6 mb-8">
        <h2 className="text-2xl font-semibold text-green-900 mb-4">
          如果太瘦怎麼辦？
        </h2>
        <ul className="list-disc pl-6 text-gray-700 mb-4">
          <li>
            如果你體重太輕（像
            BMI&lt;21），建議請營養師幫忙做飲食規劃。吃得對，身體比較有力氣，肺也比較有力氣幫你呼吸。
          </li>
          <li>
            另外，吃進去有營養，要搭配運動才會變成肌肉。簡單走路、練腳力，喘的情況也會變少，活動力會進步。
          </li>
        </ul>
        <h2 className="text-2xl font-semibold text-green-900 my-4">延伸學習</h2>
        <ul className="list-disc pl-6 text-gray-700 mb-2">
          <li>
            <a
              href="https://epaper.ntuh.gov.tw/health/202109/health_1.html"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 underline break-words"
            >
              慢性阻塞性肺病營養照護影片
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Nutrition;
